import { render } from "./Workspace.vue?vue&type=template&id=0845778d"
const script = {}
script.render = render

export default script